import api from './config';

export const auditAPI = {
  getStats: async () => {
    const res = await api.get('/audit/stats');
    return res.data.data;
  },

  getAll: async (filters = {}, page = 1, limit = 50) => {
    const params = new URLSearchParams({ page, limit });
    if (filters.module)   params.append('module',   filters.module);
    if (filters.action)   params.append('action',   filters.action);
    if (filters.userId)   params.append('userId',   filters.userId);
    if (filters.status)   params.append('status',   filters.status);
    if (filters.dateFrom) params.append('dateFrom', filters.dateFrom);
    if (filters.dateTo)   params.append('dateTo',   filters.dateTo);
    if (filters.entityId) params.append('entityId', filters.entityId);
    if (filters.search)   params.append('search',   filters.search);
    const res = await api.get(`/audit?${params.toString()}`);
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/audit/${id}`);
    return res.data.data;
  },
};

export default auditAPI;
